import styled from "styled-components";
import { keyframes } from "styled-components";
import { sliderToOpacity } from "../../utils/helpers";
import { Switch } from "@material-ui/core";

export const MainDiv = styled.div`
  position: relative;
  height: 92vh;
  width: 100vw;
  overflow-x: hidden;
  background: ${({ isEmptyWheel }) =>
    isEmptyWheel === true || isEmptyWheel === "true" ? "#00000059" : null};

  /* Only apply zoom responsiveness for extreme zoom IN scenarios */
  @media (max-width: 900px) {
    min-width: 800px;
  }

  /* No zoom out restrictions */
`;

// export const WheelWallpaperImage = styled.div`
//   height: 100%;
//   position: absolute;
//   width: 100%;
//   z-index: -1;
//   background-image: ${({ currentBg, bgWallpaper }) =>
//     currentBg === 2 && bgWallpaper !== ""
//       ? `url(${bgWallpaper})`
//       : bgWallpaper};
//   object-fit: contain;
//   background-position: stretch;
//   background-repeat: no-repeat;
//   background-attachment: fixed;
//   background-size: 100% 100%;
//   opacity: ${({ wallpaperTransparency }) =>
//     sliderToOpacity(wallpaperTransparency)};
// `;

export const WheelWallpaperImage = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
  background-image: ${({ currentBg, bgWallpaper }) =>
    currentBg === 2 && bgWallpaper !== ""
      ? `url(${bgWallpaper})`
      : bgWallpaper};
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover; /* Use cover to maintain aspect ratio */
  opacity: ${({ wallpaperTransparency }) =>
    sliderToOpacity(wallpaperTransparency)}; */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ wallpaperHueColor }) =>
      wallpaperHueColor ?? "#ffffff"};
    mix-blend-mode: multiply;
    pointer-events: none;
  }
`;
export const WheelWallpaperColor = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
  background-color: ${({ color }) => color};
  opacity: ${({ wallpaperTransparency }) =>
    sliderToOpacity(wallpaperTransparency)};
`;

export const LeftSection = styled.div`
  width: 100%;
  height: 92vh;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 400px;

  /* Responsive adjustments for different zoom levels */
  @media (max-width: 1400px) {
    padding: 0 10px;
  }

  @media (max-width: 1200px) {
    min-width: 350px;
  }
`;

export const Container = styled.div`
  height: 40px;
  width: 360px;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  width: 38.98px;
  height: 38.98px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SegmentButton = styled.div`
  width: 126px;
  height: 38px;
  background-color: #ffffff;
  border-radius: 100px;
  padding: 9px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SegmentText = styled.p`
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  margin: 0;
  display: flex;
  align-items: center;

  user-select: none; /* For most browsers */
  -webkit-user-select: none; /* For Safari */
  -moz-user-select: none; /* For Firefox */
`;

export const LabelWrapper = styled.div`
  width: 152px;
  height: 38px;
  background-color: #ffffff;
  border-radius: 100px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const LabelText = styled.p`
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  margin: 0;
`;

export const StyledSwitch = styled(Switch)`
  width: 50px;
  height: 35px;
`;

export const MenuContainer = styled.div`
  width: 130px;
  height: 68px;
  border-radius: 5px;
  position: absolute;
  top: -10vh;
  right: ${({ right }) => `${right}vw`};
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;
  z-index: 1000;

  /* Only apply responsive positioning for zoom IN scenarios (smaller screens) */
  @media (max-width: 1200px) {
    min-width: 120px;
  }

  @media (max-width: 900px) {
    min-width: 110px;
  }
`;

export const MenuItem = styled.p`
  margin: 0;
  padding: 4px 8px;
  border-bottom: 1px solid #eee;
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 500;
  line-height: 25.9px;
  text-align: left;

  user-select: none; /* For most browsers */
  -webkit-user-select: none; /* For Safari */
  -moz-user-select: none; /* For Firefox */

  &:last-child {
    border-bottom: none;
  }

  img {
    margin-right: 4px;
  }
`;

export const moveArrow = keyframes`
  0% { transform: translateX(0); }
  50% { transform: translateX(-10px); }
  100% { transform: translateX(0); }
`;

export const AnimatedDiv = styled.div`
  position: absolute;
  left: calc(50% + 92px);
  display: flex;
  align-items: center;
  animation: ${moveArrow} 1s infinite;
`;

export const IndicatorDiv = styled.div`
  width: 8vw;
  min-width: 134px;
  height: 5vh;
  min-height: 40px;
  border-radius: 8px;
  background: linear-gradient(45deg, #f7fed5, #ccfeff, #fdcffe, #f5eede);
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #ccfeff;
  }
`;

export const FlexMainDiv = styled.div`
  display: flex;
  height: 92vh;
  width: 100%;
  overflow: hidden;

  /* Only apply zoom responsiveness for extreme zoom IN scenarios */
  @media (max-width: 900px) {
    min-width: 700px;
    overflow-x: auto;
  }

  /* No restrictions for zoom out - let it expand naturally */
`;
